import { DEFAULT_LOCALE, localeCodes } from "../i18n/locales.js";
import { absoluteUrl } from "./metaDefaults.js";
import { getEntityAlternatePaths } from "./routeRecords.js";

export function buildAlternates(record) {
  const paths = getEntityAlternatePaths(record);
  const alternates = localeCodes.map((lang) => ({
    hreflang: lang,
    href: absoluteUrl(paths[lang])
  }));

  alternates.push({
    hreflang: "x-default",
    href: absoluteUrl(paths[DEFAULT_LOCALE])
  });

  return alternates;
}
